// extracted by mini-css-extract-plugin
export var notificationHost = "_da-0";